import React, {Fragment} from "react";
import {Autocomplete} from "@material-ui/lab";
import {CircularProgress, Grid, TextField, Typography} from "@material-ui/core";
import {GoogleMaps} from "../../context/GoogleMapsContext";

const LAT = -41.2490477, LNG = 174.7001303, RADIUS = 1000;

let session, ok, location;

function renderOption(option){
    return (
        <Grid container direction="column">
            <Typography variant="body1">
                {option.main_text}
            </Typography>
            <Typography variant="caption" color="textSecondary">
                {option.secondary_text}
            </Typography>
        </Grid>
    )
}

class GooglePlacesAutocompleteField extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            query: props.value,
            options: [],
            loading: false
        }
        this.replies = {}
        this.initGoogle();
    }

    initGoogle(){
        const api = window.google.maps;
        if (!session){
            ok = api.places.PlacesServiceStatus.OK;
            session = new api.places.AutocompleteSessionToken();
            location = new api.LatLng(LAT, LNG)
        }
        this.service = new api.places.AutocompleteService();
    }

    checkCache(term){
        const reply = this.replies[term]
        if (reply){
            this.setState({
                options: reply,
                loading: false
            })
            return true;
        }
        return false;
    }

    fetch(value){
        if (!/[^\d\s]+/.test(value)){
            this.setState({
                options: [],
                loading: false
            })
            return
        }
        if (this.checkCache(value)){
            return;
        }
        this.service.getPlacePredictions(
            {
                input: value,
                sessionToken: session,
                location: location,
                radius: RADIUS
            },
            (results, status) => {
                if (status !== ok) {
                    results = [];
                }
                const loading = value !== this.state.query
                results = results.map(result => result.structured_formatting)
                this.replies[value] = results;
                this.setState({
                    options: results,
                    loading: loading
                })
                if (loading){
                    this.fetch(this.state.query);
                }
            }
        );
    }

    autocomplete(e){
        const value = e.target.value
        if (this.state.loading){
            this.setState({
                query: value
            })
            return
        }
        this.setState({
            loading: true,
            query: value
        })
        this.fetch(value)
    }

    textField(props){
        return (
            <TextField
                {...props}
                variant="outlined"
                onChange={this.autocomplete.bind(this)}
                label={this.props.label}
                size={this.props.size}
                InputProps={{
                    ...props.InputProps,
                    endAdornment: (
                        <Fragment>
                            {this.state.loading ? <CircularProgress color="primary" size={20}/> : null}
                            {props.InputProps.endAdornment}
                        </Fragment>
                    )
                }}
                error={this.props.error}
                fullWidth
            />
        )
    }

    render(){
        const {options, loading} = this.state;
        return (
            <Fragment>
                <Autocomplete
                    options={options}
                    loading={loading}
                    renderInput={this.textField.bind(this)}
                    renderOption={renderOption}
                    getOptionLabel={option => option.main_text || option}
                    filterOptions={options => options}
                    autoHighlight={false}
                    getOptionSelected={(option) => option === options[0]}
                    {...this.props}
                    onChange={(e, value) => {
                        value = value ? value.main_text + ", " + value.secondary_text : "";
                        this.props.onChange(value);
                    }}
                    inputValue={this.props.value}
                    onInputChange={(e, value) => {
                        this.props.onChange(value);
                    }}
                    error={undefined}
                />
            </Fragment>
        );
    }
}

export default function(props){
    return (
        <GoogleMaps.Consumer>{
            maps => maps.loaded ? (
                <GooglePlacesAutocompleteField {...props}/>
            ) : ""
        }</GoogleMaps.Consumer>
    );
};